function processPlayerStats(stats = {}, projections = {}) {
  for (const [key, v] of Object.entries(projections)) {
    stats[`proj_${key}`] = v
  }
  return stats
}

function makePrice({ player, price, match, fantasyXFP }) {
  const priced = price?.prices?.[match]?.price
  if (priced) return priced

  const value = player?.stats?.proj_value || fantasyXFP?.value
  if (value) return +value.toFixed(1)

  return null
}

export default {
  processPlayerStats,
  makePrice,
};
